import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  plan: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: null,
  },
};

export const planSlice = createSlice({
  name: "plan",
  initialState: INITIAL_STATE,
  reducers: {
    fetchPlans: (state) => {
      state.plan.isLoading = true;
    },
    fetchPlansSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      plan: {
        ...state.plan,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    fetchPlansFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      plan: {
        ...state.plan,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    clearPlan: (state) => ({
      ...state,
      plan: {
        ...state.plan,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: null,
        statusText: null,
        data: null,
      },
    }),
  },
});

export const { fetchPlans, fetchPlansFailure, fetchPlansSuccess, clearPlan } =
  planSlice.actions;
export const PlanReducer = planSlice.reducer;
